module.exports = __webpack_public_path__ + "img/memory.1ed1e88d.svg";